// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__jhkgS","desktop":"Logo_desktop__88_e0","mobile":"Logo_mobile__vmC_K"};